module.exports = __webpack_public_path__ + "img/avatar.9a850357.png";